// These files are for translating the react app UI
// First level is namespace
// Default namespace is `common`.
// Usage in app: t('countries:fi')
// No need to define default namespace: t('save')
export default {
  app: {
    name: 'Product Integration Hub',
    shortName: 'PIH',
  },
  countries: {
    be_BY: 'Belarus',
    bg_BG: 'Bulgaria',
    cs_CZ: 'Czech Republic',
    da_DK: 'Denmark',
    de_AT: 'Austria',
    de_CH: 'Switzerland',
    de: 'Germany',
    en_US: 'North America (English)',
    en: 'Global (English)',
    es: 'Spain',
    fi: 'Finland',
    fr_CA: 'North America (French)',
    fr: 'France',
    it: 'Italy',
    ja_JP: 'Japan',
    ko_KR: 'Korea',
    nl_NL: 'Netherlands',
    no: 'Norway',
    pl_PL: 'Poland',
    ro_RO: 'Romania',
    ru_KZ: 'Kazakhstan',
    ru_RU: 'Russia',
    sv: 'Sweden',
    tr_TR: 'Turkey',
    uk_UA: 'Ukraine',
    zh_CN: 'China',
    hu: 'Hungary',
    it_CH: 'Switzerland (Italian)',
    fr_CH: 'Switzerland (French)',
  },
  languages: {
    cs_CZ: 'Czech',
    de: 'German',
    en: 'English',
    en_US: 'North America (English)',
    es: 'Spanish',
    fi: 'Finnish',
    fr: 'French',
    fr_CA: 'North America (French)',
    it: 'Italian',
    nl_NL: 'Dutch',
    no: 'Norwegian',
    pl_PL: 'Polish',
    sv: 'Swedish',
  },
  errors: {
    'Password token invalid': 'Password reset link has expired. <0>Please request a new one.</0>', // comes from server in this format. <0> is replaced with link tags
    API_ENDPOINT_NOT_FOUND: 'Api endpoint not found. Please contact support.',
    INTERNAL_SERVER_ERROR: 'An error occurred. Please try again later.',
    PASSWORD_REQUIRED: 'Password is required',
    PASSWORD_TOO_SHORT: 'New password must be at least {{len}} characters',
    UNAUTHORIZED: 'You are not authorized to perform this action',
  },
  common: {
    backHome: 'Back home',
    backToSearch: 'Back to search',
    cancel: 'Cancel',
    cancelChanges: 'Cancel changes',
    close: 'Close',
    containsUnpunblishedChanges: 'This draft contains unpublished changes',
    create: 'Create',
    draft: 'Draft',
    fieldIsRequired: '{{field}} is required',
    invalidCodeFormat: 'Invalid code format. Allowed characters are uppercase letters A-Z, numbers, dash or colon, space, dot and plus sign. Sample: IF-1342-AA or IF:1342:AA',
    loading: 'Loading',
    master: 'master',
    no: 'No',
    notFound: 'Version not found',
    notPublished: 'Product has not been published',
    or: 'or',
    pageNotFound: 'Oops! Page not found',
    publishChanges: 'Publish',
    published: 'Published',
    remove: 'Remove',
    save: 'Save',
    saveAndPublishChanges: 'Save changes & publish',
    saveChanges: 'Save changes',
    savedSuccessfully: 'Saved successfully',
    search: 'Search',
    showAll: 'Show all',
    yes: 'Yes',
  },
  nav: {
    feeds: 'Feeds',
    itemFamilies: 'Item families',
    items: 'Items',
    logout: 'Logout',
    savedSearches: 'Saved searches',
    settings: 'Settings',
    tyreAwards: 'Tyre awards',
    wheels: 'Wheels',
    treads: 'Treads',
    catalog: 'Catalog',
  },
  pins: {
    pageIsPinned: 'This page is pinned',
    pinnedItems: 'Pinned items',
    pinPage: 'Pin this page',
    unpin: 'Unpin item',
    unpinPage: 'Unpin page',
  },
  user: {
    changePassword: 'Change password',
    currentPassword: 'Current password',
    currentPasswordPlaceholder: 'Enter current password',
    firstName: 'First name',
    lastName: 'Last name',
    newPassword: 'New password',
    newPasswordConfirm: 'Confirm new password',
    newPasswordLength: 'New password must be at least {{len}} characters',
    newPasswordPlaceholder: 'Enter new password',
    newPasswordsMustMatch: 'New passwords must match',
    savedSuccessfully: 'Changes saved',
    settings: 'Settings',
    username: 'Username',
    userSettings: 'User settings',
  },
  login: {
    fieldIsRequired: '{{field}} is required',
    forgotPassword: 'Forgot your password?',
    login: 'Log in',
    loginError: 'Login failed.',
    password: 'Password',
    passwordPlaceholder: 'Enter your password',
    togglePasswordVisibility: 'Toggle password visibility',
    username: 'Username',
    usernamePlaceholder: 'Enter your e-mail',
  },
  forgotPassword: {
    email: 'E-mail',
    emailPlaceholder: 'Enter your e-mail',
    emailSent: 'An email has been sent to you with the password reset link',
    helper: 'If you\'ve forgotten your password, please enter your registered email address below, and we\'ll send you a link to recover your password.',
    send: 'Send request',
    signIn: 'Sign in',
  },
  resetPassword: {
    newPassword: 'New password',
    newPasswordConfirm: 'Confirm new password',
    passwordPlaceholder: 'Enter new password',
    reset: 'Reset',
    success: 'Password has been reset. You may now <0>login</0>.',
  },
  itemFamily: {
    addBackboneText: 'Add new backbone text',
    addBullet: 'Add new list item',
    addBulletButton: 'Add item',
    addMarketingBullet: 'Add new bullet point',
    addImages: 'Add images',
    addItemLine: 'Add new item line',
    addNew: 'New item family',
    application: 'Application',
    attributes: 'Attributes',
    attributesGuarantee: 'Guarantee attributes',
    availableInMarket: 'Available in market',
    backbone: 'Backbone',
    brand: 'Brand',
    chooseAttributes: 'Choose attributes',
    chooseFeeds: 'Choose feeds to be included in',
    chooseGuaranteeAttributes: 'Choose guarantee attributes',
    code: 'Item family code',
    codeHelperText: 'Item family code is used to connect items from MDS to item families. Must match values from MDS.',
    comingSoon: 'Coming soon',
    comingSoonHelpText: '',
    comingSoonAttributePresent: 'This product is marked as "coming soon".',
    containsUnpunblishedChanges: 'This draft contains unpublished changes',
    content: 'Content',
    draft: 'Draft',
    equipment: 'Equipment',
    features: 'Features',
    feeds: 'Feeds',
    generatePdfs: 'Generate PDFs',
    image25degreeFull: '25 degree full',
    image25degreeHalf: '25 degree half',
    imageCut3d: 'Cut 3d',
    imageFrontFull: 'Front full',
    imageFrontHalf: 'Front half',
    imageMain: 'Main image',
    images: 'Images',
    imageSideFull: 'Side full',
    invalidCodeFormat: 'Invalid code format. Allowed characters are uppercase letters A-Z, numbers, dash or colon, space, dot and plus sign. Sample: IF-1342-AA or IF:1342:AA',
    itemFamily: 'Item family',
    itemLines: 'Item lines',
    lastChanged: 'Last change date',
    loadCapacityCommentHelp: 'Text shown under load capacity tables in certificates and technical manual for all items in this item family. Can be overridden on item level.',
    marketingBullets: 'Marketing bullet points',
    marketingName: 'Marketing name',
    marketingSlogan: 'Marketing slogan',
    marketingText: 'Marketing text',
    marketingTextShort: 'Short marketing text',
    marketingTextTitle: 'Marketing text title',
    marketingVideo: 'Marketing video',
    markets: 'Available in markets',
    metaDescription: 'Meta description',
    metaTitle: 'Meta title',
    moodImages: 'Mood images',
    name: 'Item family name',
    nameHelp: 'Family name without Nokian Tyres brand',
    nameHelpPC1: 'Example Hakkapeliitta 10, without Nokian Tyres brand',
    nameHelpPC24: 'Example Forest King F, without Nokian Tyres brand',
    noAwards: 'No awards for this product found',
    noReviews: 'No reviews for this product found',
    notFound: 'Version not found',
    notPublished: 'Item family has not been published',
    outOfProduction: 'Out of production',
    published: 'Published',
    removeItemLine: 'Remove',
    season: 'Season',
    showItems: 'Show items',
    suitableTerrains: 'Suitable terrains',
    tagline: 'Tagline',
    tyreAwards: 'Tyre awards',
    usageGroup: 'Usage group',
    userReviews: 'User reviews',
    vehicleType: 'Vehicle type',
    vehicleTypeDescription: 'Vehicle type description',
    videos: 'Videos',
    youtubeVideoUrl: 'Youtube video url',
  },
  item: {
    actualTotalTreadDepth: 'Actual total tread depth',
    additionalMarking: 'Additional marking',
    applicationCode: 'Application code',
    applicableProductSizes: 'Applicable product sizes',
    aspectRatio: 'Aspect ratio',
    beltsBreakers: 'Belts breakers',
    brand: 'Brand',
    carcassMaterial: 'Carcass material',
    certificate: 'Certificate',
    certificateInfo: 'Certificate info',
    dynamicRollingRadius: 'Dynamic rolling radius',
    ean: 'EAN',
    euDirectiveNumber: 'EU directive number',
    euLabelInfo: 'EU label info',
    family: 'Family',
    flapProduct: 'Flap product',
    footPrintAreaHardSurface: 'Footprint area hard surface',
    iceGrip: 'Ice grip',
    imageEuLabel: 'EU Label image',
    imperial: 'Imperial units',
    internalVolume: 'Internal volume',
    itemCode: 'Item code',
    itemFamilies: 'Item families',
    itemFamily: 'Item family',
    itemLifeCycle: 'Life cycle',
    itemName: 'Item name',
    items: 'Items',
    lastChanged: 'Last change date',
    loadCapacityComment: 'Load capacity comment',
    loadCapacityCommentHelp: 'Text shown under load capacity tables in certificates and technical manual',
    loadedStaticRadius: 'Loaded static radius',
    loadIndex: 'Load index',
    loadIndexDual: 'Load index dual',
    loadIndexSpeedSymbol: 'Load index, speed symbol',
    maxDiameterInService: 'Maximum diameter in service',
    maxWidthInService: 'Maximum width in service',
    measuredDiameter: 'Measured diameter',
    measuredLength: 'Length',
    measuredWeight: 'Weight',
    measuredWidth: 'Measured width',
    minDualSpacing: 'Minimum dual spacing',
    mudSnowMarking: 'Mud and snow marking (M+S)',
    noiseClass: 'Noise class',
    noisePerformance: 'Noise performance',
    numberOfStudsAllowed: 'Number of studs allowed',
    overrideImageMain: 'Override main image',
    PorMarking: 'Professional off-road marking (POR)',
    price: 'Price',
    priceDiscounted: 'Discounted price',
    pricing: 'Pricing (RU)',
    primaryUse: 'Primary use',
    prStarRating: 'PR Star rating',
    recommendedStud: 'Recommended stud',
    regroovable: 'Regroovable',
    reinforcedCode: 'Reinforced code',
    rim: 'Rim',
    rimPermittedSizes: 'Permitted rim sizes',
    rimRecommendedSize: 'Recommended rim size',
    rollingCircumference: 'Rolling circumference',
    rollingResistance: 'Rolling resistance',
    runFlat: 'Run flat',
    salt: 'Salt',
    secondaryUse: 'Secondary use',
    snowGrip: 'Snow grip',
    speedIndex: 'Speed index',
    speedRadiusIndex: 'Speed radius index',
    structureCode: 'Structure code',
    studdable: 'Studdable',
    studMarking: 'Stud marking',
    technicalInfo: 'Technical info',
    totalWeightIncrease: 'Total weight increase',
    tractionMarking: 'Traction marking',
    traTiretype: 'TRA tire type',
    treadDepth: 'Pattern depth',
    tubeProduct: 'Tube product',
    typeApproval: 'Type approval',
    tyreClass: 'Tyre class',
    valveTubeless: 'Valve tubeless',
    valveTubeType: 'Valve tube type',
    water: 'Water',
    waterAndSaltBallasting: 'Water and salt ballasting',
    waterFilling: 'Water filling',
    weight: 'Weight',
    weightPerMeter: 'Weight',
    wetGrip: 'Wet grip',
    width: 'Width',
    treadItems: 'Tread items'
  },
  itemSearch: {
    addRow: 'Add another search row',
    all: 'All',
    any: 'Any',
    clearSearch: 'Clear search',
    deleteSavedSearch: 'Delete',
    equals: 'is',
    field: 'Field',
    itemCode: 'Item (T-code)',
    itemFamilyCode: 'Item family',
    itemLifeCycle: 'Life cycle',
    loadingResults: 'Loading results...',
    matchSearchCriteria: 'Match search criteria',
    noneOf: 'is not any of',
    noResults: 'No results found for this query, please try another',
    noSavedSearches: 'You have no saved searches',
    notEqual: 'is not',
    oneOf: 'is one of',
    operator: 'Operator',
    parameters: 'Parameters',
    removeRow: 'Remove search row',
    results: 'Search results',
    savedSearches: 'Saved searches',
    saveSearch: 'Save search',
    searchItems: 'Search items',
    searchSavedSuccessfully: 'Search saved successfully',
    showResults: 'Show results',
    value: 'Value',
  },
  // studioFilePicker: {
  //   addFiles: 'Add files',
  //   selectFile: 'Select file',
  //   selectFileForField: 'Select file for field',
  //   selectFiles: 'Select files',
  //   selectFilesForField: 'Select files for field',
  // },
  filePicker: {
    addFiles: 'Add files',
    change: 'Change',
    remove: 'Remove',
    selectFile: 'Select file',
    selectFileForField: 'Select file for field',
    selectFiles: 'Select files',
    selectFilesForField: 'Select files for field',
    viewLarger: 'View larger',
  },
  // fileViewer: {
  //   view: 'View'
  // },
  feeds: {
    contentType: 'Content type',
    dragHelp: 'Drag list items to change their order.',
    feed: 'Feed',
    feeds: 'Feeds',
    format: 'Format',
    items: 'Feed content',
    readers: 'Feed readers',
    saveOrder: 'Save order',
    viewDetails: 'View details',
    preview: 'Preview feed',
    name: 'Name',
    accessGiven: 'Access given',
    url: 'Url',
    copyUrl: 'Copy url',
    urlCopiedToClipboard: 'Url copied to clipboard',
    errorCopyingUrl: 'Error copying url',
    tyres: 'Tyres',
    rims: 'Wheels',
  },
  tyreAwards: {
    addNew: 'Add review',
    award: 'Award',
    country: 'Country',
    itemFamily: 'Item family',
    magazine: 'Magazine',
    noResults: 'No results found for this query, please try another',
    product: 'Product',
    review: 'Review',
    season: 'Season',
    seasons: {
      autumn: 'Autumn',
      summer: 'Summer',
      winter: 'Winter',
    },
    tyreAwards: 'Tyre awards',
    year: 'Year',
    edit: 'Edit award',
    add: 'Add award',
    publication: 'Publication',
    issue: 'Issue',
    issueHelper: 'Example format: 4/2021',
    productTitle: 'Product',
    awardTitle: 'Award',
    awardName: 'Award name (localized)',
    awardNameHelper: 'Placement or award name. Needs to be set for award to show.',
    reviewInfo: 'Review (localized)',
    reviewHelper: 'Shown on product page award list. Needs to be set for award to show.',
    highlight: 'Highlight (localized)',
    highlightHelper: 'The newest award with highlight is showcased on product page.',
    translations: 'Translations',
    translationFor: 'Translation for {{country}}',
    isPublished: 'Is published',
    publishedInfo: '(Only published awards are shown on site)',
    yes: 'Yes',
    no: 'No',
    editTranslation: 'Edit translation',
    publicationDate: 'Publication date',
    publicationDateHelper: 'Publication date as YYYY-MM-DD',
    magazineLogo: 'Logo of the magazine',
    magazineLogoAlt: 'Magazine logo',
    testSeason: 'Test season',
    overrideLogo: 'Logo to override magazine logo',
    productInfo: 'Item',
    productInfoHelper: 'Reviewed item, for example "235/60R18"',
    translationHelper: 'If published, the current language version of award is shown only if its award and review fields have content.',
    translationUpdated: 'Translation updated successfully.',
    awardAdded: 'Tyre award added successfully.',
    awardUpdated: 'Tyre award updated',
  },
  userReviews: {
    comment: 'Review comment',
    date: 'Date',
    overallRating: 'Overall rating <0>{{average}}</0> - based on <0>{{amount}}</0> reviews',
    rating: 'Rating',
    title: 'Review title',
    username: 'Username',
  },
  wheel: {
    attributes: 'Attributes',
    addImages: 'Add images',
    addNew: 'New wheel',
    brand: 'Brand',
    chooseAttributes: 'Choose attributes',
    chooseFeeds: 'Choose feeds to be included in',
    code: 'Code',
    codeHelperText: '',
    content: 'Content',
    features: 'Features',
    feeds: 'Feeds',
    imageMain: 'Main image',
    imageRender: 'Render image',
    imageCut3d: 'Cut 3D',
    images: 'Images',
    itemFamilies: 'Compatible item families for this wheel',
    lastChanged: 'Last change date',
    machines: 'Machines',
    marketingText: 'Marketing text',
    name: 'Name',
    nameHelp: 'Example Backhoe Wheel Xtreme, without Nokian Tyres brand',
    notPublished: 'Wheel has not been published',
    otherImages: 'Other images',
    productLines: 'Product lines',
    wheel: 'Wheel',
    wheels: 'Wheels',
    workTypes: 'Type of work',
  },
  tread: {
    addBackboneText: 'Add new backbone text',
    addBullet: 'Add new list item',
    addBulletButton: 'Add item',
    addImages: 'Add images',
    addItemLine: 'Add new item line',
    addNew: 'New tread',
    attributes: 'Attributes',
    availableInMarket: 'Available in market',
    backbone: 'Backbone',
    brand: 'Brand',
    chooseAttributes: 'Choose attributes',
    chooseFeeds: 'Choose feeds to be included in',
    code: 'Item family code',
    codeHelperText: 'Item family code is used to connect items from MDS to item families. Must match values from MDS.',
    containsUnpunblishedChanges: 'This draft contains unpublished changes',
    content: 'Content',
    draft: 'Draft',
    equipment: 'Equipment',
    features: 'Features',
    feeds: 'Feeds',
    image25degreeFull: '25 degree full',
    imageFrontFull: 'Front full',
    imageMain: 'Main image',
    imageSurfacePattern: 'Surface pattern',
    images: 'Images',
    invalidCodeFormat: 'Invalid code format. Allowed characters are uppercase letters A-Z, numbers, dash or colon, space, dot and plus sign. Sample: IF-1342-AA or IF:1342:AA',
    itemLines: 'Item lines',
    lastChanged: 'Last change date',
    marketingBullets: 'Marketing bullet points',
    marketingName: 'Marketing name',
    marketingSlogan: 'Marketing slogan',
    marketingText: 'Marketing text',
    marketingTextShort: 'Short marketing text',
    marketingTextTitle: 'Marketing text title',
    marketingVideo: 'Marketing video',
    markets: 'Available in markets',
    name: 'Tread name',
    nameHelp: 'Example E-tread 32, without Nokian Tyres brand',
    notFound: 'Version not found',
    notPublished: 'Tread has not been published',
    outOfProduction: 'Out of production',
    published: 'Published',
    removeItemLine: 'Remove',
    season: 'Season',
    showItems: 'Show items',
    suitableTerrains: 'Suitable terrains',
    tagline: 'Tagline',
    tread: 'Tread',
    treads: 'Treads',
    treadSizes: 'Suitable tyre sizes',
    tyrePosition: 'Tyre position',
    usageGroup: 'Usage group',
    vehicleType: 'Vehicle type',
  },
  catalog: {
    catalog: 'Catalog',
    generate: 'Generate',
    generateProductCatalog: 'Generate product catalog PDF',
    generating: 'PDF generation in process, please wait...',
    generationComplete: 'PDF generation complete',
    generationError: 'PDF generation failed',
    language: 'Language',
    openFile: 'Open PDF',
    print: 'Print',
    target: 'Target',
    web: 'Web',
    withPrices: 'Include prices',
    type: 'Type',
    types: {
      heavy: 'Heavy',
      tbr: 'TBR',
      noktop: 'Noktop',
      pct: 'Full',
    }
  },
  suitableTyreSizes: {
    suitableTyreSizes: 'Suitable tyre sizes',
  }
};
